import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import 'moment/locale/pt-br';
import { BusinessProcessService } from '../../../services/business-process.service';
import { BusinessProcess } from '../../../Models/businessProcess';
import { HumanInteractionTokenResult } from '../../../Models/humanInteractionTokenResult';
import { Utils } from '../../../services/utils';
import {HumanInteractionService} from "../../../services/human-interaction.service";

@Component({
  selector: 'app-instance-list',
  templateUrl: './businessProcessStartList.component.html',
  styleUrls: ['./businessProcessStartList.component.css']
})
export class BusinessProcessStartListComponent implements OnInit {

  businessProcess$: Observable<BusinessProcess[]>;
  bpItens: BusinessProcess[];
  localTimeZone: string;
  utilsFunctions = Utils;
  errorMessage = '';
  initializingInstance = false;

  constructor(private bpService: BusinessProcessService, private humanInteractionService: HumanInteractionService, private router: Router) { }

  ngOnInit() {
    this.localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.businessProcess$ = this.bpService.getPublishedBusinessProcesses;
    this.businessProcess$.subscribe( result => {
      this.bpItens = result;
    }, error1 => this.errorMessage = error1);
  }

  onStartBusinessProcess(businessProcessId: number, initiateQuickInstance: boolean) {
    this.initializingInstance = true;
    if (initiateQuickInstance) {
      this.humanInteractionService.startBusinessProcess(businessProcessId)
        .subscribe(result => {
          if (result.hasError) {
            this.initializingInstance = false;
            alert(`Erro ao tentar iniciar instância: ${result.errorMessage}`);
            return;
          }
          if (result.hasTimeOut || !result.continueExecution) {
            this.initializingInstance = false;
            alert(`Instância ${result.instanceId} criada`);
            return;
          }
          if (result.continueExecution) {
            this.initializingInstance = false;
            this.bpService.openWindowInteraction(result.instanceId, false);
          }
      }, error1 => {
          this.initializingInstance = false;
          this.errorMessage = error1;
        });
      return;
    }
    this.bpService.openWindowNewInstance(businessProcessId);
    this.initializingInstance = false;
  }
}
